module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp12_5012.f1afcf33.png";